export const SignOutDialogName = 'SignOutDialogComponent';
